import React from "react";
import "./Card.css";

const Card = props => {
  return (
    <div
      className="card dark component-card"
      style={{ padding: "20px", margin: "20px" }}
    >
      <div>{props.children}</div>
    </div>
  );
};

export default Card;
